/* Approved builder destination: shared by every draft layout, not only Studio. */
(() => {
  const normalizeBuilderLink = link => {
    if (link.hasAttribute('data-original-page') || link.closest('.fs-review,.qr-review,[aria-label="Design comparison"]')) return;
    const raw = link.getAttribute('href');
    if (!raw) return;
    let url;
    try { url = new URL(raw, location.href); } catch (_) { return; }
    if (url.origin !== location.origin || url.pathname !== '/pages/biltong') return;
    if (!['bundle-builder','quality-builder','studio-builder'].includes(url.searchParams.get('view'))) return;
    url.searchParams.set('view','studio-builder');
    const next = url.pathname + url.search + url.hash;
    if (raw !== next) link.setAttribute('href',next);
  };
  const scan = root => {
    if (root.matches?.('a[href]')) normalizeBuilderLink(root);
    root.querySelectorAll?.('a[href]').forEach(normalizeBuilderLink);
  };
  scan(document);
  document.addEventListener('click',event=>{const link=event.target.closest('a[href]');if(link)normalizeBuilderLink(link);},true);
  new MutationObserver(records=>records.forEach(record=>{
    if(record.type==='attributes')normalizeBuilderLink(record.target);
    else record.addedNodes.forEach(scan);
  })).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['href']});
})();
/* End approved builder destination. */
(() => {
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const money = cents => {
    const value = (Number(cents || 0) / 100).toFixed(2);
    const format = window.joburgTheme?.moneyFormat;
    return format ? format.replace(/\{\{\s*amount[^}]*\}\}/, value) : `$${value}`;
  };
  const analytics = window.joburgAnalytics;
  const attribution = analytics?.attribution || {page_audience: 'general'};
  const track = (event, detail = {}) => analytics?.track(event, detail);
  window.joburgTrack = track;
  const focusableElements = root => $$('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', root)
    .filter(element => !element.hidden && element.getAttribute('aria-hidden') !== 'true' && (element.offsetWidth || element.offsetHeight));
  const trapFocus = (event, root) => {
    if (event.key !== 'Tab' || !root) return;
    const focusable = focusableElements(root);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };
  const parseJSONNode = selector => {
    try { return JSON.parse($(selector)?.textContent || '{}'); } catch (_) { return {}; }
  };
  const productAnalyticsItem = (root = document) => {
    const truth = parseJSONNode('[data-product-truth]', root);
    const offer = parseJSONNode('[data-product-offer]', root);
    return {
      item_id: String(truth.product_id || ''),
      variant_id: String(offer.variant_id || truth.variant_id || ''),
      item_name: truth.display_title || window.joburgTheme?.productTitle || '',
      flavor: truth.flavor_key || '',
      pack_size: truth.format || '',
      quantity: 1,
      price_cents: Number(offer.total_price || 0)
    };
  };
  const formAnalyticsItem = form => ({
    item_id: String(form?.dataset.productId || ''),
    variant_id: String(form?.querySelector('[name="id"]')?.value || form?.dataset.variantId || ''),
    item_name: form?.dataset.productTitle || '',
    flavor: form?.dataset.productFlavor || '',
    pack_size: form?.dataset.packSize || '',
    price_cents: Number(form?.dataset.priceCents || 0)
  });
  const audiencePresentations = {
    performance: {
      headline: 'Protein that keeps up.',
      lede: 'Training ends. Dinner is still an hour away. Every current Joburg flavor delivers 36g protein in a 2 oz pouch of recognizable whole-muscle beef.',
      cta: 'Fuel the next gap'
    },
    fitness: {
      headline: 'Protein that keeps up.',
      lede: 'Training ends. Dinner is still an hour away. Every current Joburg flavor delivers 36g protein in a 2 oz pouch of recognizable whole-muscle beef.',
      cta: 'Fuel the next gap'
    },
    on_the_go: {
      headline: 'Steak goes places now.',
      lede: 'Boarding gate. Beach bag. Glove box. Joburg puts recognizably real beef where a steak dinner cannot go.',
      cta: 'Pack the variety'
    },
    travel: {
      headline: 'Steak goes places now.',
      lede: 'Boarding gate. Beach bag. Glove box. Joburg puts recognizably real beef where a steak dinner cannot go.',
      cta: 'Pack the variety'
    },
    heritage_kosher: {
      headline: 'Glatt Kosher. Ready anywhere.',
      lede: 'South African-inspired Steak Slices made in our own U.S. facility—portable, shelf-stable while sealed, and ready for the day between meals.',
      cta: 'Meet the lineup'
    },
    kosher: {
      headline: 'Glatt Kosher. Ready anywhere.',
      lede: 'South African-inspired Steak Slices made in our own U.S. facility—portable, shelf-stable while sealed, and ready for the day between meals.',
      cta: 'Meet the lineup'
    },
    whole_food: {
      headline: 'Real beef. Nothing to mix.',
      lede: 'Whole-muscle Steak Slices with a short ingredient list, a recognizably steak-like bite, and no sweet bar pretending to be lunch.',
      cta: 'Choose real food'
    },
    parents: {
      headline: 'Ready for the day between meals.',
      lede: 'School pickup, errands, practice, traffic. Keep real-food protein in the family bag for the schedule nobody plans perfectly.',
      cta: 'Find the family pack'
    },
    low_carb: {
      headline: 'Low-carb options. Real steak bite.',
      lede: 'Traditional currently has 0g sugar and 0g total carbohydrate per 2 oz pouch. Nutrition varies by flavor, so the current pouch always wins.',
      cta: 'Shop current flavors'
    }
  };
  const drawer = $('#CartDrawer');
  const mobileToggle = $('[data-mobile-toggle]');
  const mobileNav = $('#MobileNav');
  let lastFocus;
  const setMobileNav = open => {
    if (!mobileToggle || !mobileNav) return;
    mobileNav.classList.toggle('is-open', open);
    mobileNav.hidden = !open;
    mobileToggle.setAttribute('aria-expanded', String(open));
    if (open) $('a[href]', mobileNav)?.focus();
    else mobileToggle.focus();
  };
  const openDrawer = () => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.inert = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    $('.icon-button[data-cart-close]', drawer)?.focus();
    track('cart_opened', {cart_value: window.joburgCartState?.total_price || 0, cart_items: window.joburgCartState?.item_count || 0});
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    document.body.classList.remove('drawer-open');
    lastFocus?.focus?.();
  };
  const progressMarkup = total => {
    const threshold = Number(window.joburgTheme?.freeShippingThreshold || 0);
    if (!threshold) return '';
    const remaining = Math.max(0, threshold - total);
    const percent = Math.min(100, Math.round(total / threshold * 100));
    const text = remaining ? `You're ${money(remaining)} from free shipping` : 'You unlocked free shipping';
    return `<span>${text}</span><div class="shipping-progress__bar" aria-hidden="true"><span style="width:${percent}%"></span></div>`;
  };
  const escapeHTML = value => String(value || '').replace(/[&<>'"]/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[character]));
  const bundleIdFor = item => item.properties && item.properties._joburg_bundle_id ? String(item.properties._joburg_bundle_id) : '';
  const bundleTierPercent = count => count >= 12 ? 10 : count >= 9 ? 7 : count >= 5 ? 5 : 0;
  const bundlePricing = lines => {
    const count = lines.reduce((sum, line) => sum + Number(line.quantity || 0), 0);
    const subscriptionBase = lines.reduce((sum, line) => sum + Number(line.original_line_price ?? line.final_line_price ?? 0), 0);
    const original = lines.reduce((sum, line) => {
      const compareAt = Number(line.selling_plan_allocation?.compare_at_price || 0);
      return sum + (compareAt ? compareAt * Number(line.quantity || 0) : Number(line.original_line_price ?? line.final_line_price ?? 0));
    }, 0);
    const current = lines.reduce((sum, line) => sum + Number(line.final_line_price || 0), 0);
    const quantitySavings = Math.max(0, subscriptionBase - current);
    const actualSavings = Math.max(0, original - current);
    const tierPercent = bundleTierPercent(count);
    const subscribed = lines.every(line => line.selling_plan_allocation);
    return {count, original, current, actualSavings, quantitySavings, tierPercent, subscribed};
  };
  const bundleSubscriptionMarkup = () => '';
  const bundlePriceMarkup = lines => {
    const price = bundlePricing(lines);
    if (price.actualSavings > 0) return `<div class="bundle-price-status bundle-price-status--active"><span>Savings applied by Shopify</span><s>${money(price.original)}</s><strong>${money(price.current)}</strong><small>You save ${money(price.actualSavings)} in this cart.</small></div>`;
    return `<div class="bundle-price-status"><strong>Current box price ${money(price.current)}</strong><small>Shopify confirms eligible discounts across your cart.</small></div>`;
  };
  const cartCommerceStatusMarkup = cart => {
    const bundles = [...new Set(cart.items.map(bundleIdFor).filter(Boolean))];
    if (!bundles.length) return '';
    const subscribed = cart.items.filter(item => bundleIdFor(item)).every(item => item.selling_plan_allocation);
    const promoPolicy = window.joburgTheme?.subscriptionAcquisitionPromoEnabled && subscribed
      ? `<p><b>First-payment campaign:</b> enter your ${escapeHTML(window.joburgTheme.subscriptionAcquisitionPromoLabel || 'qualifying campaign code')} at checkout. Shopify keeps whichever is greater—the code or quantity tier—and the subscription price applies after that. The code does not renew.</p>`
      : '';
    return `<section class="cart-commerce-status" aria-label="Box pricing and subscription status"><strong>Your checkout status</strong><p><b>Cart discounts:</b> ${cart.total_discount > 0 ? `${money(cart.total_discount)} applied by Shopify.` : 'none applied in this cart yet.'}</p><p><b>Subscription:</b> ${subscribed ? 'selected on every pouch. Recurring deliveries begin after checkout.' : 'one-time and subscription choices are shown on each item.'}</p>${promoPolicy}</section>`;
  };
  const lineMarkup = (item, bundled = false) => `<div class="drawer-line${bundled ? ' drawer-line--bundled' : ''}">
    <a href="${escapeHTML(item.url)}"><img src="${item.image ? escapeHTML(item.image + '&width=160') : ''}" alt="${escapeHTML(item.product_title)}" width="78" height="78"></a>
    <div><h3><a href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a></h3>${item.selling_plan_allocation ? `<small class="drawer-line__schedule">Subscription · ${escapeHTML(item.selling_plan_allocation.selling_plan.name)}</small>` : '<small class="drawer-line__schedule">One-time purchase</small>'}${item.variant_title ? `<small>${escapeHTML(item.variant_title)}</small>` : ''}${bundled ? `<small>${item.quantity} pouch${item.quantity === 1 ? '' : 'es'}</small>` : `<div class="drawer-line__controls"><button type="button" aria-label="Decrease ${escapeHTML(item.product_title)}" data-cart-change="${escapeHTML(item.key)}" data-qty="${Math.max(0,item.quantity-1)}">−</button><span>${item.quantity}</span><button type="button" aria-label="Increase ${escapeHTML(item.product_title)}" data-cart-change="${escapeHTML(item.key)}" data-qty="${item.quantity+1}">+</button></div>`}</div>
    <strong>${money(item.final_line_price)}</strong>
  </div>`;
  const cartItemsMarkup = cart => {
    const renderedBundles = new Set();
    return cart.items.map(item => {
      const bundleId = bundleIdFor(item);
      if (!bundleId) return lineMarkup(item);
      if (renderedBundles.has(bundleId)) return '';
      renderedBundles.add(bundleId);
      const lines = cart.items.filter(candidate => bundleIdFor(candidate) === bundleId);
      const name = item.properties._joburg_bundle_name || 'Joburg flavor box';
      const count = lines.reduce((sum, line) => sum + line.quantity, 0);
      return `<section class="drawer-bundle" data-cart-bundle="${escapeHTML(bundleId)}"><header><div><span>Built your way</span><strong>${escapeHTML(name)}</strong><small>${count} pouch${count === 1 ? '' : 'es'}</small></div><div class="cart-box-actions"><a href="/pages/biltong?view=studio-builder&edit_box=${encodeURIComponent(bundleId)}#bundle-builder">Edit this box</a><button type="button" data-cart-remove-bundle="${escapeHTML(bundleId)}">Remove box</button></div></header>${bundlePriceMarkup(lines)}${bundleSubscriptionMarkup(bundleId, lines)}${lines.map(line => lineMarkup(line, true)).join('')}</section>`;
    }).join('');
  };
  const renderCart = cart => {
    window.joburgCartState = cart;
    $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count ? `(${cart.item_count})` : '');
    const countBadge = $('[data-header-cart-count]'); if (countBadge) countBadge.textContent = cart.item_count;
    const items = $('[data-cart-items]', drawer);
    const footer = $('[data-cart-footer]', drawer);
    if (!items || !footer) return;
    items.innerHTML = cart.item_count ? cartItemsMarkup(cart) : '<div class="empty-state"><h3>Your cart is ready for something delicious.</h3><a class="button" href="/collections/all">Shop steak snacks</a></div>';
    footer.hidden = !cart.item_count;
    $('[data-cart-total]', drawer).textContent = money(cart.total_price);
    $('[data-shipping-progress]', drawer).innerHTML = progressMarkup(cart.total_price);
    $('[data-cart-commerce-status]', drawer).innerHTML = cartCommerceStatusMarkup(cart);
    const upsell = $('[data-cart-upsell]', drawer);
    if (upsell) upsell.hidden = cart.items.some(item => bundleIdFor(item));
  };
  const getCart = async () => {
    const response = await fetch(`${window.joburgTheme.cartUrl}.js`, {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Cart unavailable');
    const cart = await response.json(); renderCart(cart); return cart;
  };
  document.addEventListener('click', async event => {
    const tracked = event.target.closest('[data-track-event]');
    if (tracked) {
      const trackedDetail = {
        location: tracked.dataset.trackLocation || '',
        destination: tracked.dataset.trackDestination || '',
        choice: tracked.dataset.trackChoice || '',
        href: tracked.getAttribute('href') || ''
      };
      if (tracked.dataset.trackEvent === 'select_flavor') trackedDetail.flavor = trackedDetail.choice;
      if (tracked.dataset.trackEvent === 'select_pack_size') trackedDetail.pack_size = trackedDetail.choice;
      track(tracked.dataset.trackEvent, trackedDetail);
    }
    const checkout = event.target.closest('a[href^="/checkout"], button[name="checkout"]');
    if (checkout) track('begin_checkout', {value_cents: window.joburgCartState?.total_price || 0, cart_items: window.joburgCartState?.item_count || 0});
    const close = event.target.closest('[data-cart-close]'); if (close) return closeDrawer();
    const open = event.target.closest('[data-cart-open]'); if (open) { event.preventDefault(); await getCart(); return openDrawer(); }
    const change = event.target.closest('[data-cart-change]');
    if (change) {
      change.disabled = true;
      await fetch(`${window.joburgTheme.cartChangeUrl}.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:change.dataset.cartChange,quantity:Number(change.dataset.qty)})});
      await getCart();
    }
    const removeBundle = event.target.closest('[data-cart-remove-bundle]');
    if (removeBundle) {
      removeBundle.disabled = true;
      const bundleId = removeBundle.dataset.cartRemoveBundle;
      const currentCart = await getCart();
      const updates = {};
      currentCart.items.filter(item => bundleIdFor(item) === bundleId).forEach(item => { updates[item.key] = 0; });
      const response = await fetch(`${window.joburgTheme.cartUpdateUrl}.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})});
      if (response.ok) {
        renderCart(await response.json());
        if (!removeBundle.closest('#CartDrawer')) window.location.reload();
      }
    }
    const subscribeBundle = event.target.closest('[data-cart-subscribe-bundle]');
    if (subscribeBundle) {
      const container = subscribeBundle.closest('[data-bundle-subscription-upsell]');
      const planId = Number($('[data-cart-subscription-plan]', container)?.value || 0);
      const bundleId = subscribeBundle.dataset.cartSubscribeBundle;
      if (!planId || !bundleId) return;
      subscribeBundle.disabled = true;
      subscribeBundle.textContent = 'Updating exact box…';
      try {
        const currentCart = await getCart();
        const lines = currentCart.items.filter(item => bundleIdFor(item) === bundleId);
        for (const line of lines) {
          const response = await fetch(`${window.joburgTheme.cartChangeUrl}.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:line.key,quantity:line.quantity,selling_plan:planId})});
          if (!response.ok) throw new Error('Subscription could not be applied to every pouch.');
        }
        const updatedCart = await getCart();
        track('subscription_frequency_selected', {purchase_type:'subscription', selling_plan_id:planId, bundle_id:bundleId, source:'cart_exact_box'});
        if (!subscribeBundle.closest('#CartDrawer')) window.location.reload(); else renderCart(updatedCart);
      } catch (error) {
        let restored = false;
        try {
          const partialCart = await getCart();
          const partialLines = partialCart.items.filter(item => bundleIdFor(item) === bundleId && item.selling_plan_allocation);
          for (const line of partialLines) {
            const rollback = await fetch(`${window.joburgTheme.cartChangeUrl}.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:line.key,quantity:line.quantity,selling_plan:null})});
            if (!rollback.ok) throw new Error('Rollback failed');
          }
          await getCart();
          restored = true;
        } catch (rollbackError) {
          await getCart().catch(() => {});
        }
        alert(restored ? `${error.message} Your box remains a one-time purchase.` : `${error.message} Please review the purchase type shown on every item before checkout.`);
        subscribeBundle.disabled = false;
        subscribeBundle.textContent = 'Subscribe & save 10%';
      }
    }
    const qty = event.target.closest('[data-quantity-change]');
    if (qty) { const input = $(qty.dataset.target); if (input) { input.value = Math.max(1, Number(input.value || 1) + Number(qty.dataset.quantityChange)); input.dispatchEvent(new Event('change',{bubbles:true})); } }
    const preset = event.target.closest('[data-quantity-preset]');
    if (preset) {
      const form = preset.closest('form'); const input = $('[name="quantity"]', form);
      if (input) { input.value = preset.dataset.quantityPreset; input.dispatchEvent(new Event('change',{bubbles:true})); }
      $$('[data-quantity-preset]', form).forEach(button => { const active = button === preset; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
      track('purchase_option_selected', {...formAnalyticsItem(form), purchase_type: 'one_time', quantity: Number(preset.dataset.quantityPreset)});
    }
    const stickySubmit = event.target.closest('[data-sticky-submit]');
    if (stickySubmit) {
      const form = $('.product-form');
      const submit = form && $('[type="submit"]', form);
      if (submit) submit.click();
    }
    const thumb = event.target.closest('[data-gallery-image],[data-gallery-primary]');
    if (thumb) {
      const gallery = thumb.closest('.product-gallery');
      const mainFrame = $('.product-gallery__main', gallery);
      const main = $('img', mainFrame);
      const thumbImage = $('img', thumb);
      const nextImage = thumb.dataset.galleryImage || thumbImage?.currentSrc || thumbImage?.src;
      if (main && nextImage) {
        main.src = nextImage;
        main.srcset = '';
        main.alt = thumb.dataset.galleryAlt || thumbImage?.alt || '';
        mainFrame.dataset.galleryFit = thumb.dataset.galleryFit || 'contain';
        $$('[data-gallery-image],[data-gallery-primary]', gallery).forEach(button => {
          const active = button === thumb;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      }
    }
    const mobile = event.target.closest('[data-mobile-toggle]');
    if (mobile) setMobileNav(mobile.getAttribute('aria-expanded') !== 'true');
    const filterToggle = event.target.closest('[data-collection-filter-toggle]');
    if (filterToggle) {
      const filters = filterToggle.closest('.collection-filters');
      const open = filters?.classList.toggle('is-open') || false;
      filterToggle.setAttribute('aria-expanded', String(open));
    }
    const video = event.target.closest('[data-youtube-embed]');
    if (video) {
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(video.dataset.youtubeEmbed)}?autoplay=1`;
      iframe.title = video.dataset.youtubeTitle || 'Joburg video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      video.replaceWith(iframe);
      track('podcast_cta_clicked', {location: video.dataset.trackLocation || 'episode_video', destination: 'video_play'});
    }
      const reelButton = event.target.closest('[data-instagram-reel-load]');
      if (reelButton) {
        const poster = reelButton.closest('[data-instagram-reel]');
        const reelUrl = poster?.dataset.instagramUrl?.replace(/\/+$/, '');
        if (!poster || !reelUrl) return;
      const iframe = document.createElement('iframe');
      const reelId = reelUrl.match(/\/reel\/([A-Za-z0-9_-]+)(?:\/|$)/)?.[1];
      if (!reelId) return;
      iframe.src = `https://www.instagram.com/reel/${reelId}/embed/`;
      iframe.title = poster.dataset.instagramTitle || 'Joburg Instagram reel';
      iframe.loading = 'lazy';
        iframe.allow = 'autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share';
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.allowFullscreen = true;
        const embed = document.createElement('div');
        embed.className = 'social-reel-card__embed';
        const fallback = document.createElement('a');
        fallback.className = 'button button--small social-reel-card__embed-fallback';
        fallback.href = reelUrl;
        fallback.target = '_blank';
        fallback.rel = 'noopener noreferrer';
        fallback.textContent = 'Open on Instagram ↗';
        embed.append(iframe, fallback);
        poster.classList.add('is-playing');
        poster.replaceChildren(embed);
        track('social_reel_embed_requested', {source: 'instagram', title: poster.dataset.instagramTitle || ''});
      }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-ajax-cart-form]'); if (!form) return;
    event.preventDefault();
    const submit = $('[type="submit"]', form); if (submit) { submit.disabled = true; submit.dataset.label = submit.innerHTML; submit.textContent = 'Adding…'; }
    try {
      const response = await fetch(`${window.joburgTheme.cartAddUrl}.js`, {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      if (!response.ok) throw new Error('Unable to add this item');
      const quantity = Number($('[name="quantity"]', form)?.value || 1);
      const item = formAnalyticsItem(form);
      track('add_to_cart', {...item, quantity, value_cents: item.price_cents * quantity, source: form.matches('[data-cart-upsell-form]') ? 'cart_upsell' : 'product_form'});
      await getCart(); openDrawer();
    } catch (error) { alert(error.message); }
    finally { if (submit) { submit.disabled = false; submit.innerHTML = submit.dataset.label; } }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && mobileToggle?.getAttribute('aria-expanded') === 'true') {
      setMobileNav(false);
      return;
    }
    if (drawer?.getAttribute('aria-hidden') !== 'false') return;
    if (event.key === 'Escape') closeDrawer();
    else trapFocus(event, $('.drawer__panel', drawer));
  });
  $$('[data-product-select]').forEach(select => select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const form = select.closest('form');
    const id = $('[name="id"]', form); if (id) id.value = option.value;
    const price = $('[data-product-price]'); if (price) price.textContent = option.dataset.price;
    const submit = $('[type="submit"]', form); if (submit) { submit.disabled = option.dataset.available !== 'true'; submit.innerHTML = submit.disabled ? 'Sold out' : `Add to cart · <span data-add-total>${option.dataset.price}</span>`; }
    form.dataset.variantId = option.value;
    form.dataset.priceCents = option.dataset.priceCents || form.dataset.priceCents;
  }));
  $$('[name="selling_plan"]').forEach(input => input.addEventListener('change', () => {
    const form = input.closest('form');
    if (input.value) {
      track('subscription_frequency_selected', {...formAnalyticsItem(form), purchase_type: 'subscription', selling_plan_id: input.value, subscription_frequency: input.dataset.frequency || ''});
    } else {
      track('purchase_option_selected', {...formAnalyticsItem(form), purchase_type: 'one_time'});
    }
  }));
  $$('[data-ajax-cart-form]').forEach(form => {
    const quantity = $('[name="quantity"]', form); const total = $('[data-add-total]', form); const price = $('[data-product-price]');
    if (!quantity || !total || !price) return;
    const updateTotal = () => {
      const selectedPlan = $('[name="selling_plan"]:checked', form);
      const baseCents = selectedPlan?.value ? Number(selectedPlan.dataset.planPrice) : Number(form.dataset.priceCents);
      const formatted = money(baseCents * Math.max(1, Number(quantity.value || 1)));
      const currentTotal = $('[data-add-total]', form); if (currentTotal) currentTotal.textContent = formatted;
      price.textContent = money(baseCents);
      const stickyTotal = $('[data-sticky-buy-total]'); if (stickyTotal) stickyTotal.textContent = formatted;
    };
    quantity.addEventListener('change', updateTotal); quantity.addEventListener('input', updateTotal);
    form.addEventListener('change', event => { if (event.target.matches('[name="selling_plan"], [data-product-select]')) updateTotal(); });
  });
  const stickyBuy = $('[data-sticky-buy]'); const purchaseForm = $('.product-form');
  if (stickyBuy && purchaseForm && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => stickyBuy.classList.toggle('is-hidden', entries[0].isIntersecting), {threshold:.15}).observe(purchaseForm);
  }
  const healthShopDock = $('[data-health-shop-dock]');
  const healthShopTrigger = $('.brand-page--why-flavor-first .health-start');
  if (healthShopDock && healthShopTrigger) {
    const healthShopBlockers = $$('.brand-page--why-flavor-first .health-case__cta, .brand-page--why-flavor-first .doctor-proof .text-link, .brand-page--why-flavor-first .brand-page__closer .button');
    let healthShopTicking = false;
    const updateHealthShopDock = () => {
      const productChoicesPassed = healthShopTrigger.getBoundingClientRect().bottom <= 0;
      const anotherShopLinkVisible = healthShopBlockers.some(element => {
        const rect = element.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      });
      const visible = productChoicesPassed && !anotherShopLinkVisible;
      healthShopDock.classList.toggle('is-visible', visible);
      healthShopDock.setAttribute('aria-hidden', String(!visible));
      if (visible) healthShopDock.removeAttribute('tabindex'); else healthShopDock.setAttribute('tabindex', '-1');
      healthShopTicking = false;
    };
    const requestHealthShopUpdate = () => {
      if (healthShopTicking) return;
      healthShopTicking = true;
      window.requestAnimationFrame(updateHealthShopDock);
    };
    updateHealthShopDock();
    window.addEventListener('scroll', requestHealthShopUpdate, {passive:true});
    window.addEventListener('resize', requestHealthShopUpdate);
  }
  $$('[data-flavor-filter-root]').forEach(root => {
    const buttons = $$('[data-flavor-filter]', root);
    const formatButtons = $$('[data-format-filter]', root);
    const cards = $$('.product-card[data-product-flavor]', root);
    const count = $('[data-collection-count]', root);
    const empty = $('[data-flavor-empty]', root);
    const caseBuilderCallout = $('[data-case-builder-callout]', root);
    if (!cards.length) return;
    let activeFlavor = 'all';
    let activeFormat = 'all';
    const applyFilters = () => {
      let visible = 0;
      cards.forEach(card => {
        const flavorMatch = activeFlavor === 'all' || card.dataset.productFlavor === activeFlavor;
        const formatMatch = activeFormat === 'all' || card.dataset.productFormat === activeFormat;
        const show = flavorMatch && formatMatch;
        card.hidden = !show;
        if (show) visible += 1;
      });
      buttons.forEach(button => {
        const active = button.dataset.flavorFilter === activeFlavor;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      formatButtons.forEach(button => {
        const active = button.dataset.formatFilter === activeFormat;
        button.classList.toggle('is-active', active);
        if (button.matches('a')) {
          if (active) button.setAttribute('aria-current', 'page'); else button.removeAttribute('aria-current');
        } else button.setAttribute('aria-pressed', String(active));
      });
      if (count) count.textContent = `${visible} ${visible === 1 ? 'product' : 'products'}`;
      if (empty) empty.hidden = visible !== 0;
      if (caseBuilderCallout) caseBuilderCallout.hidden = activeFormat !== 'case';
      const sortForm = root.querySelector('.collection-toolbar form');
      if (sortForm) {
        [['pack', activeFormat], ['flavor', activeFlavor]].forEach(([name, value]) => {
          let field = sortForm.querySelector(`input[name="${name}"]`);
          if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = name; sortForm.append(field); }
          field.value = value;
        });
      }
      const url = new URL(window.location.href);
      if (activeFlavor === 'all') url.searchParams.delete('flavor'); else url.searchParams.set('flavor', activeFlavor);
      if (activeFormat === (root.dataset.defaultFormat || 'all')) url.searchParams.delete('pack'); else url.searchParams.set('pack', activeFormat);
      history.replaceState({}, '', url);
      track('collection_filtered', {flavor: activeFlavor, format: activeFormat, visible_products: visible});
    };
    buttons.forEach(button => button.addEventListener('click', () => {
      activeFlavor = button.dataset.flavorFilter;
      track('select_flavor', {flavor: activeFlavor, source: 'collection_filter'});
      applyFilters();
    }));
    formatButtons.filter(button => !button.matches('a')).forEach(button => button.addEventListener('click', () => {
      activeFormat = button.dataset.formatFilter;
      track('select_pack_size', {pack_size: activeFormat, source: 'collection_filter'});
      applyFilters();
    }));
    const requested = new URLSearchParams(window.location.search).get('flavor');
    const requestedFormat = new URLSearchParams(window.location.search).get('pack');
    activeFlavor = buttons.some(button => button.dataset.flavorFilter === requested) ? requested : 'all';
    const defaultFormat = root.dataset.defaultFormat || 'all';
    activeFormat = formatButtons.some(button => button.dataset.formatFilter === requestedFormat) ? requestedFormat : defaultFormat;
    applyFilters();
  });
  if ('IntersectionObserver' in window) {
    const viewedSections = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const sectionEvent = entry.target.closest('.life-page') ? 'real_life_moment_viewed' : entry.target.closest('.flavor-lab') ? 'flavor_lab_section_viewed' : 'health_page_section_viewed';
        track(sectionEvent, {moment: entry.target.dataset.trackSection || '', section: entry.target.dataset.trackSection || ''});
        viewedSections.unobserve(entry.target);
      });
    }, {threshold:.35});
    $$('[data-track-section]').forEach(section => viewedSections.observe(section));
    const viewedStories = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        track('health_audience_story_viewed', {story: entry.target.dataset.audienceStory || ''});
        viewedStories.unobserve(entry.target);
      });
    }, {threshold:.5});
    $$('[data-audience-story]').forEach(story => viewedStories.observe(story));
  }
  $$('[data-track-faq]').forEach(item => item.addEventListener('toggle', () => {
    if (item.open) track('real_life_faq_opened', {question: item.dataset.trackFaq || ''});
  }));
  if ($('.life-page')) {
    const moments = $('.life-moments');
    const momentsToggle = $('[data-life-moments-toggle]');
    const expandMoments = (source = 'button') => {
      if (!moments || moments.dataset.lifeMomentsExpanded === 'true') return;
      moments.dataset.lifeMomentsExpanded = 'true';
      if (momentsToggle) momentsToggle.setAttribute('aria-expanded', 'true');
      track('real_life_more_moments_opened', {source});
    };
    momentsToggle?.addEventListener('click', () => expandMoments('button'));
    $$('a[href="#training"],a[href="#family"],a[href="#hosting"]').forEach(link => link.addEventListener('click', () => expandMoments('jump-link')));
    if (['#training', '#family', '#hosting'].includes(window.location.hash)) expandMoments('direct-link');
    const presentation = audiencePresentations[attribution.page_audience];
    if (presentation) {
      const headline = $('[data-audience-headline]');
      const lede = $('[data-audience-lede]');
      const cta = $('[data-audience-cta]');
      if (headline) headline.textContent = presentation.headline;
      if (lede) lede.textContent = presentation.lede;
      if (cta) cta.textContent = presentation.cta;
      document.documentElement.dataset.audience = attribution.page_audience;
      track('real_life_audience_applied', {audience: attribution.page_audience});
    }
    const finder = $('[data-life-finder]');
    if (finder) {
      const choices = $$('[data-life-choice]', finder);
      const resultLabel = $('[data-life-result-label]', finder);
      const resultTitle = $('[data-life-result-title]', finder);
      const resultCopy = $('[data-life-result-copy]', finder);
      const resultLink = $('[data-life-result-link]', finder);
      const mobileBuy = $('[data-life-mobile-buy]');
      const mobileLabel = $('[data-life-mobile-label]');
      const mobileTitle = $('[data-life-mobile-title]');
      choices.forEach(button => {
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => {
          try { sessionStorage.setItem('joburgRealLifeMoment', button.dataset.lifeChoice || ''); } catch (_) {}
          choices.forEach(choice => {
            const active = choice === button;
            choice.classList.toggle('is-active', active);
            choice.setAttribute('aria-pressed', String(active));
          });
          if (resultLabel) resultLabel.textContent = button.dataset.resultLabel || '';
          if (resultTitle) resultTitle.textContent = button.dataset.resultTitle || '';
          if (resultCopy) resultCopy.textContent = button.dataset.resultCopy || '';
          if (resultLink) {
            resultLink.href = button.dataset.resultUrl || '#pack-guide';
            resultLink.textContent = button.dataset.resultCta || 'Shop this pack';
            resultLink.dataset.trackChoice = button.dataset.lifeChoice || '';
          }
          if (mobileBuy) {
            mobileBuy.href = button.dataset.resultUrl || '#pack-guide';
            mobileBuy.dataset.trackDestination = button.dataset.lifeChoice || 'recommendation';
            mobileBuy.dataset.trackChoice = button.dataset.lifeChoice || '';
          }
          if (mobileLabel) mobileLabel.textContent = button.dataset.resultLabel || 'Your recommendation';
          if (mobileTitle) mobileTitle.textContent = button.dataset.resultCta || 'Shop this pack';
          track('real_life_moment_selected', {choice: button.dataset.lifeChoice || '', recommendation: button.dataset.resultTitle || ''});
        });
      });
    }
    const reached = new Set();
    const recordDepth = () => {
      const scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      const percent = Math.round(window.scrollY / scrollable * 100);
      [25, 50, 75, 90].forEach(mark => {
        if (percent < mark || reached.has(mark)) return;
        reached.add(mark);
        track('real_life_scroll_depth', {percent: mark});
      });
    };
    window.addEventListener('scroll', recordDepth, {passive: true});
    track('real_life_landing_viewed', {page_title: document.title});
  }
  const flavorLab = $('[data-flavor-lab]');
  if (flavorLab) {
    const flavorForm = $('#FlavorLabForm', flavorLab);
    const heatFollowup = $('[data-heat-followup]', flavorForm);
    const heatLevelInputs = $$('[name="contact[Heat level]"]', flavorForm);
    const heatStyleInputs = $$('[data-heat-style]', flavorForm);
    const syncHeatFollowup = () => {
      const heatLevel = flavorForm?.querySelector('[name="contact[Heat level]"]:checked')?.value || '';
      const wantsHeat = heatLevel !== '' && heatLevel !== 'No heat';
      if (heatFollowup) heatFollowup.hidden = !wantsHeat;
      heatStyleInputs.forEach(input => {
        input.required = wantsHeat;
        if (!wantsHeat) input.checked = false;
      });
    };
    heatLevelInputs.forEach(input => input.addEventListener('change', syncHeatFollowup));
    syncHeatFollowup();
    flavorForm?.addEventListener('change', event => {
      const input = event.target;
      if (!input.matches('input[type="radio"]')) return;
      track('flavor_lab_answer_selected', {question: input.name.replace(/^contact\[|\]$/g, ''), answer: input.value});
    });
    flavorForm?.addEventListener('submit', () => {
      const selected = name => flavorForm.querySelector(`[name="contact[${name}]"]:checked`)?.value || '';
      track('taste_panel_completed', {
        flavor: selected('Flavor vote'),
        intensity: selected('Flavor intensity'),
        texture: selected('Preferred texture'),
        heat: selected('Heat level'),
        heat_style: selected('Preferred heat style'),
        occasion: selected('Primary occasion'),
        test_batch_opt_in: Boolean(flavorForm.querySelector('[name="contact[Test batch opt-in]"]:checked'))
      });
    });
    track('flavor_lab_viewed', {page_title: document.title});
  }
  const tastePanel = $('[data-taste-panel]');
  if (tastePanel) {
    const tab = $('[data-taste-panel-open]', tastePanel);
    const panel = $('.taste-panel__drawer', tastePanel);
    const backdrop = $('.taste-panel__backdrop', tastePanel);
    const closeButtons = $$('[data-taste-panel-close]', tastePanel);
    const join = $('[data-taste-panel-join]', tastePanel);
    let lastTastePanelFocus;
    const revealTastePanel = source => {
      tab.hidden = false;
      requestAnimationFrame(() => tab.classList.add('is-visible'));
      track('taste_panel_invite_shown', {source});
    };
    const openTastePanel = () => {
      lastTastePanelFocus = document.activeElement;
      panel.inert = false;
      panel.setAttribute('aria-hidden', 'false');
      backdrop.hidden = false;
      tab.setAttribute('aria-expanded', 'true');
      document.body.classList.add('taste-panel-open');
      $('.taste-panel__close', tastePanel)?.focus();
      track('taste_panel_opened');
    };
    const closeTastePanel = () => {
      panel.setAttribute('aria-hidden', 'true');
      panel.inert = true;
      backdrop.hidden = true;
      tab.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('taste-panel-open');
      lastTastePanelFocus?.focus?.();
      track('taste_panel_invite_dismissed');
    };
    tab?.addEventListener('click', openTastePanel);
    closeButtons.forEach(button => button.addEventListener('click', closeTastePanel));
    join?.addEventListener('click', () => track('taste_panel_invite_accepted'));
    document.addEventListener('keydown', event => {
      if (panel.getAttribute('aria-hidden') !== 'false') return;
      if (event.key === 'Escape') closeTastePanel();
      else trapFocus(event, panel);
    });
    revealTastePanel('persistent');
  }
  if (window.joburgTheme?.pageType === 'product') track('view_item', productAnalyticsItem());
  if (window.joburgTheme?.pageType === 'collection') track('collection_viewed', {collection: window.joburgTheme.collectionHandle});
  if ($('.brand-page--why')) track('health_landing_viewed', {page_title: document.title});
  getCart().then(cart => {
    if (window.joburgTheme?.pageType === 'cart') track('view_cart', {value_cents: cart.total_price || 0, cart_items: cart.item_count || 0});
  }).catch(() => {});
})();
